import instance from "@/utils/request";

function postRequest(url, data) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "post",
      data,
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function getRequest(url) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "get",
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function queryTimeline() {
  return getRequest("/website/businessMovement/queryTimeline");
}

export function getBusiness(data) {
  return postRequest("/website/businessMovement/list", data);
}
